import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { AdalService } from 'adal-angular4';
import { AccountService, IUser } from './account/shared/account.service';
import { BlobStorageService } from './shared/blob-storage.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  user: IUser | null = null;
  avatar$?: Observable<string>;
  version = environment.version;

  constructor(
    private _adalService: AdalService,
    private _accountService: AccountService,
    private _blobStorageService: BlobStorageService,
  ) { }

  async ngOnInit() {
    this._adalService.init(environment.adal);
    this._adalService.handleWindowCallback();
    if (!this._adalService.userInfo.authenticated) {
      this._adalService.login();
    }

    this.user = await this._accountService.whoAmI();
    if (this.user && this.user.id) {
      this.avatar$ = this._blobStorageService.getAvatar(this.user.id);
    }
  }

  signOut() {
    this._adalService.logOut();
  }
}
